import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getRangeOptions,
  getSelectedRangeOption
} from "../../../../utils/date-range-options";

import {
  FETCH_DATA_SUCCESS,
  FETCH_CURRENT_USER_SUCCESS,
  UPDATE_DATA_SUCCESS,
  RESET_DATA_SUCCESS,
  SET_LOADING,
  SET_UPDATES_LOADING,
  SET_DATES,
  UPDATE_DATES,
  UPDATE_CUSTOM_RANGE
} from "./salesSaga";

export const actionCreators = {};

const initialState = {
  currentUser: {},
  initialRequest: false,
  isLoading: true,
  filtersDirty: false,
  isUpdating: false,
  allValues: {},
  selectedRequestDates: {},
  dataPoints: [],
  pieCharts: {},
  tableData: { data: [], colHeaders: [] },
  rangeOptions: [],
  selectedRangeOption: {}
};

export default handleActions(
  {
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [FETCH_DATA_SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload,
      allValues: { ...state.allValues, ...payload }
    }),
    [UPDATE_DATA_SUCCESS]: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    [RESET_DATA_SUCCESS]: (state) => ({
      ...state,
      dataPoints: state.allValues.dataPoints,
      pieCharts: state.allValues.pieCharts,
      tableData: state.allValues.tableData
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      isUpdating: action.payload,
      filtersDirty: false
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptions(action.payload.endDate, action.payload.calendarStartDate),
      selectedRangeOption: getSelectedRangeOption(action)
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action),
      filtersDirty: true
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload.data,
      selectedRequestDates: getDateRanges(
        action.payload.calendarEndDate,
        action.payload.data,
        action.payload.calendarStartDate
      ),
      filtersDirty: true
    })
  },
  initialState
);
